// TODO: clean up props
<template>
  <div v-if="!finished" class="quiz-actions">
    <button @click.prevent="$emit('next')" class="btn btn-primary">
      შემდეგი
    </button>
  </div>
</template>

<script>
export default {
  props: ['next', 'finished'],
  data() {
    return {};
  },
  methods: {},

  mounted() {},
};
</script>
<style lang="scss">
.quiz-actions {
  text-align: right;
  &.fixed {
    position: fixed;
    bottom: 90px;
    right: 60px;
    @media (max-width: 768px) {
      bottom: 33px;
      right: initial;
      left: 50%;
      transform: translateX(-60%);
    }
  }
}
</style>
